import moment from 'moment'
import { OFFER_TYPE_LAST_MINUTE, OFFER_TYPE_HOTEL, OFFER_TYPE_ALWAYS_ON, OFFER_TYPE_TOUR, OFFER_TYPE_BED_BANK } from 'constants/offer'
import { getVisibilityScheduleForRegion } from 'lib/offerUtils'
import { isBedbank, isTourV2Offer } from './offerTypes'

export const ENABLED_OFFER_TYPES_RECENTLY_VIEWED = new Set<App.OfferType>([
  OFFER_TYPE_HOTEL,
  OFFER_TYPE_ALWAYS_ON,
  OFFER_TYPE_LAST_MINUTE,
  'direct_tour',
  'partner_tour',
  'connection_tour',
  OFFER_TYPE_TOUR,
  OFFER_TYPE_BED_BANK,
])

export function isOfferValidWithRegion(
  offer: App.Offer | Tours.V2Offer | App.BedbankOffer | App.OfferSummary,
  region: string,
) {
  if (isTourV2Offer(offer) || isBedbank(offer)) return true

  const current = moment()
  const visibilitySchedule = getVisibilityScheduleForRegion(offer, region)
  return current.isBefore(moment(offer.bookByDate, 'YYYY-MM-DD')) &&
    (visibilitySchedule && current.isBefore(moment(visibilitySchedule.end, moment.ISO_8601)))
}
